import { axiosPrivate } from '@/shared/api/axios'
import { API } from '@/shared/constants/api'
import type { IRoleUserForm } from '../model/role.schema'

/**
 * Servicio LEGACY. Su único consumidor vivo es `user-form.tsx`, la rama v1 del flag
 * `webAuthV2`; el form v2 (`user-v2-form.tsx`) ya toma los roles de
 * `use-roles-v2-lookup-query`. Este archivo entero se borra cuando el flag sea
 * permanente en producción — no hay nada que migrar acá.
 */
export const rolesService = {
  getLookup: async () =>
    await axiosPrivate.get<IRoleUserForm[]>(API.roles.lookup).then((r) => r.data)
}
